<template>
<mdb-list-group class="">
    <mdb-list-group-item :action="true" class="no-padding" >
        <img :src="CONTENT_DOMAIN+'/'+center_image" class="img-fluid z-depth-1" width="100%"   />
    </mdb-list-group-item>
    <mdb-list-group-item :action="true" :active="true" ><span class="lead">{{center_heading}}</span>
        <router-link to="">
            <mdb-badge color="primary" class="ct-badge" pill>more</mdb-badge>
        </router-link>
    </mdb-list-group-item>
    <router-link to="" v-for="(center) in centers_block ">
        <mdb-list-group-item :action="true"  v-html="center['contentHeading']"></mdb-list-group-item>
    </router-link>
    
</mdb-list-group>
    
</template>

<script>
import axios from 'axios';
import { mdbCard, mdbCardImage, mdbCardHeader, mdbCardBody, mdbCardTitle, mdbCardText, mdbCardFooter,mdbBtn,mdbListGroup, mdbListGroupItem, mdbBadge } from 'mdbvue';
export default {
    name: 'CentersBlock',
    data(){
        return{
            centers_block:[],
            center_heading:"",
            center_image:"",
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN
        };
        
    },
    components:{
        mdbCard,mdbListGroup, mdbListGroupItem,mdbBadge,    
        mdbCardImage,
        mdbCardHeader,
        mdbCardBody,
        mdbCardTitle,
        mdbCardText,
        mdbCardFooter,
        mdbBtn
        
    },
    mounted :function(){
        this.showCentersBlock()
    },
    created:function(){
            //console.log(this.centers_block);
    },
	methods:{
        showCentersBlock(){ 
            axios.get(this.$store.state.apiUrl+'/centers_block',{
              params:{
                  id_company:this.$store.state.companyData['id_company'] ,
                  id_language:this.$store.state.companyData['id_language'],
                  id_country: this.$store.state.companyData['id_country'],
                  id_eap: this.$store.state.companyData['id_eap']               
              }
          })
          .then(response => {
              response = response.data
              //console.log(response)
              this.centers_block = response.content
              this.center_heading=response.heading
              this.center_image=response.imagepath
              this.$emit('center_ld_flag_changed');
              this.$nextTick(function () {
                
              })
              
          })
          .catch(() => {
              this.centers_block = [];
          });
      }

    }
};
</script>
<style scoped>
.no-padding{
    padding: 0;
    border: none;
}
.ct-badge{
    background-color: #dadada5c;
}
.list-group-item.active {
    background-color: #5f656dc7;
    border-color: #5f656dc7;
} 
</style>